import { emergency } from './lib/i18n/emergency.js';

/**
 * Аварийный экран: каталог локали не загрузился. Показывается вместо белой страницы.
 * Единственный компонент с захардкоженным текстом — см. lib/i18n/emergency.ts.
 */
export function BootFailure(): React.ReactElement {
  return (
    <main
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: '1rem',
        fontFamily: 'system-ui, sans-serif',
        color: '#2C2F44',
        background: '#CCCCFF',
      }}
    >
      <h1 style={{ margin: 0, fontSize: '1.5rem' }}>{emergency.title}</h1>
      <p style={{ margin: 0 }}>{emergency.message}</p>
      <button
        type="button"
        onClick={() => {
          window.location.reload();
        }}
        style={{
          padding: '0.5rem 1.25rem',
          borderRadius: '0.5rem',
          border: 'none',
          background: '#2C2F44',
          color: '#fff',
          cursor: 'pointer',
        }}
      >
        {emergency.retry}
      </button>
    </main>
  );
}
